
import {Component, Prop, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import {dataFieldsEditModule} from "@/store";
import DataFieldCache from "../../../models/data.field.cache";
import DataFieldBar from "@/components/study/datafields/base/DataFieldBar.vue";
import {translate} from "@/auxillary/translation";
import {stringify} from "@/auxillary/datafield.stringify";
import Hints from "@/components/study/datafields/base/Hints.vue";

import {findEnumValueSet, activeEnumValues} from "@/auxillary/enum.lookup";

const selectAllThreshold = 5;

@Component({
  name: 'AutocompleteField',
  components: {
    DataFieldBar,
    OkDialog,
    Hints
  },
})
export default class AutocompleteField extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache

  errorMessage: string = "";

  get displayName() {
    if (!this.dataField.displayName) return ""
    return this.dataField.displayName + (this.isRequired ? "<span style='color:red;'>*</span>" : "");
  }

  get isVisible() {
    return this.field.isVisible;
  }

  get isRequired() {
    return this.dataField.isRequired
  }

  get isReadonly() {
    return !this.field.isEditable;
  }

  get values() {
    if (this.unknown)
      return [];
    const value = this.dataField.values.value;
    return value && Array.isArray(value) ? value : [];
  }

  set values(value: any[]) {
    if (!this.unknown)
      dataFieldsEditModule.setValue({field: this.dataField, key: "value", value})
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get unknown() {
    return this.dataField.values.unknown
  }

  set unknown(value: boolean) {
    if (!this.canBeUnknown)
      return;

    dataFieldsEditModule.setValue({field: this.dataField, key: "unknown", value});

    if (value)
      dataFieldsEditModule.setValue({field: this.dataField, key: "value", value: "unknown"});
    else
      dataFieldsEditModule.setValue({field: this.dataField, key: "value", value: ""});
  }

  stringifyValue() {
    return stringify(this.field)
  }

  get field() {
    return this.dataField;
  }

  get width() {
    // TODO needs better dynnamic width
    return 100 + (Math.max(this.suffix.length - 5, 0) * 5);
  }

  get suffix() {
    return translate(this.field.definition.unit, "unit") ?? "";
  }

  get decimalSeparator() {
    return this.field.definition.decimalSeparator || ',';
  }

  get items() {
    const enumValues = Array.from(activeEnumValues(this.enumValueSet))
        .map(e => ({
          code: e.code,
          displayName: translate(e.displayKey)
        }));
    return enumValues;
  }

  get enumValueSet() {
    return findEnumValueSet(this.dataField.definition.items);
  }

  get allSelected() {
    return (this.values.length == this.items.length);
  }

  set allSelected(value: boolean) {
    if (value) {
        this.values = this.items.map(i => i.code);
        return;
    }

    this.values = [];
  }

  get selectAllThreshold() {
    return selectAllThreshold;
  }
}
